import FavouriteButton from './FavouriteButton';

export default FavouriteButton;
